/**
 * Redux slice for course ratings
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RatingsState, CourseRating } from '../types';

const initialState: RatingsState = {
  courseRatings: {},
  userRatings: {},
  loading: false,
  error: null,
};

const ratingsSlice = createSlice({
  name: 'ratings',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setCourseRatings: (state, action: PayloadAction<{ courseId: string; ratings: CourseRating[] }>) => {
      state.courseRatings[action.payload.courseId] = action.payload.ratings;
    },
    addRating: (state, action: PayloadAction<CourseRating>) => {
      const { courseId, userId } = action.payload;
      if (!state.courseRatings[courseId]) {
        state.courseRatings[courseId] = [];
      }
      // Remove existing rating from this user
      state.courseRatings[courseId] = state.courseRatings[courseId].filter(
        (r) => r.userId !== userId
      );
      // Add new rating
      state.courseRatings[courseId].push(action.payload);
      // Update user's rating
      state.userRatings[courseId] = action.payload;
    },
    updateRating: (state, action: PayloadAction<CourseRating>) => {
      const { courseId, userId } = action.payload;
      if (state.courseRatings[courseId]) {
        const index = state.courseRatings[courseId].findIndex((r) => r.userId === userId);
        if (index !== -1) {
          state.courseRatings[courseId][index] = action.payload;
        }
      }
      state.userRatings[courseId] = action.payload;
    },
    removeRating: (state, action: PayloadAction<{ courseId: string; userId: string }>) => {
      const { courseId, userId } = action.payload;
      if (state.courseRatings[courseId]) {
        state.courseRatings[courseId] = state.courseRatings[courseId].filter(
          (r) => r.userId !== userId
        );
      }
      delete state.userRatings[courseId];
    },
  },
});

export const {
  setLoading,
  setError,
  setCourseRatings,
  addRating,
  updateRating,
  removeRating,
} = ratingsSlice.actions;

export default ratingsSlice.reducer;

